var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTealArrow = function SvgTealArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9393 22.9393C10.3536 23.5251 10.3536 24.4749 10.9393 25.0607L20.4853 34.6066C21.0711 35.1924 22.0208 35.1924 22.6066 34.6066C23.1924 34.0208 23.1924 33.0711 22.6066 32.4853L14.1213 24L22.6066 15.5147C23.1924 14.9289 23.1924 13.9792 22.6066 13.3934C22.0208 12.8076 21.0711 12.8076 20.4853 13.3934L10.9393 22.9393ZM38 22.5L12 22.5L12 25.5L38 25.5L38 22.5Z",
    fill: "#137170"
  })));
};
export default SvgTealArrow;